import { REGEX } from '@/utils';
// This function formats a string containing Markdown syntax into HTML.
// It handles headers, inline formatting (bold, italic, underline, strikethrough, links).
// It does not handle block elements like lists, line breaks, etc.
export const formatMarkdownInline = (text) => {
    let html = text.trim();
    // Headers: from ###### to #
    for (let i = 6; i >= 1; i--) {
        const pattern = new RegExp(`^#{${i}}\\s+(.*)$`, 'gm');
        html = html.replace(pattern, `<h${i}>$1</h${i}>`);
    }
    // Basic inline formatting
    html = html
        .replace(REGEX.MARKDOWN_STRONG, '<strong>$1</strong>')
        .replace(REGEX.MARKDOWN_EMPHASIS, '<em>$1</em>')
        .replace(REGEX.MARKDOWN_LINK, '<a href="$2" target="_blank">$1</a>')
        .replace(REGEX.MARKDOWN_UNDERLINE, '<u>$1</u>')
        .replace(REGEX.MARKDOWN_STRIKE_THROUGH, '<del>$1</del>');
    return html;
};
